import ActivityChecker from 'javascripts/activity_checker'
import UserAvatar from 'react/components/user_avatar'
import Notifications from 'react/components/notifications'
import WidgetNotifications from 'react/containers/notifications/widget'
import CookiesDisclaimer from 'react/components/cookies_disclaimer'
import EnrollmentButton from 'react/containers/participation/enrollment_button'
import SatisfactionSurveyBanner from 'react/components/satisfaction_meter/banner'

import AbstractPack from 'packs/react/abstract_pack'
import CookiesList from 'react/components/cookies_list'
import AppSidebar from 'react/components/app_sidebar'
import { toggle as sidebarToggle } from '@components/app_sidebar/sidebar_state'

// Import video.js for HLS support on login page
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

// Make videojs available globally for login page
window.videojs = videojs

class Front extends AbstractPack {
  renderAvatar(containerId, props) {
    super.renderReactComponent(containerId, props, UserAvatar)
  }

  renderAvatars(selector) {
    super.renderReactComponents(selector, UserAvatar)
  }

  renderNotifications(containerId) {
    super.renderReactComponent(containerId, null, Notifications)
  }

  renderWidgetNotifications(containerId) {
    super.renderReactComponent(containerId, null, WidgetNotifications)
  }

  renderCookiesDisclaimer(containerId, props) {
    super.renderReactComponent(containerId, props, CookiesDisclaimer)
  }

  renderEnrollmentRequest(containerId, props) {
    super.renderReactComponent(containerId, props, EnrollmentButton)
  }

  renderCookies(containerId, props) {
    super.renderReactComponent(containerId, props, CookiesList)
  }

  renderSidebar(containerId) {
    super.renderReactComponent(containerId, null, AppSidebar)
  }

  renderSatisfactionSurveyBanner(containerId, props) {
    super.renderReactComponent(containerId, props, SatisfactionSurveyBanner)
  }
}

window.Front = new Front()
window.ActivityChecker = new ActivityChecker()
window.sidebarToggle = sidebarToggle
